"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.presentBio = void 0;
var _solidUi = require("solid-ui");
const presentBio = (subject, store) => {
  const description = store.anyJS(subject, _solidUi.ns.vcard('note'));
  return {
    description,
    entryNode: subject
  };
};
exports.presentBio = presentBio;